import React from 'react';
import { client_id, client_secret } from 'src/constants/bgCheckKeys';
import { initialOptions } from 'src/constants/initialOptionsApi';

export const useCreateBackgroundCheck = () => {
  const [loading, setLoading] = React.useState(false);

  const createBackgroundCheck = async (body, service) => {
    setLoading(true);

    const options = {
      method: 'POST',
      headers: initialOptions.headers,
      body: JSON.stringify(body),
    };
    const url = '/ExternalService/bgcreateprofile';

    try {
      const response = await fetch(url, options);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();

      if (typeof result?.data === 'string') {
        try {
          result.data = JSON.parse(result.data);
        } catch (parseError) {
          console.warn('Failed to parse result.data:', parseError);
          result.data = [];
        }
      }
      return result?.data || null; // Return the response data
    } catch (error) {
      return null;
    } finally {
      setLoading(false); // Always reset loading state
    }
  };

  return { createBackgroundCheck, loading };
};

export const useGetBackgroundCheck = () => {
  const [loading, setLoading] = React.useState(false);

  const getBackgroundCheck = async (body) => {
    setLoading(true);
    const options = {
      method: 'POST',
      headers: initialOptions.headers,
      body: JSON.stringify(body),
    };
    const url = '/ExternalService/checkbackground';

    try {
      // Fetch data from the API
      const response = await fetch(`${url}`, options);

      // Check if the response is ok (status 200-299)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      if (typeof result?.data === 'string') {
        try {
          result.data = JSON.parse(result.data);
        } catch (parseError) {
          console.warn('Failed to parse result.data:', parseError);
          result.data = [];
        }
      }
      return result?.data || null; // Return the response data
    } catch (error) {
      return null; // Re-throw the error to be handled by the caller
    } finally {
      setLoading(false); // Always reset loading state
    }
  };

  return { getBackgroundCheck, loading };
};

export const useCreateBackgroundCheckOrder = () => {
  const [loading, setLoading] = React.useState(false);

  const createBackgroundCheckOrder = async (body) => {
    setLoading(true);
    const options = {
      method: 'POST',
      headers: initialOptions.headers,
      body: JSON.stringify(body),
    };
    const url = '/ExternalService/bgplacebgorder';

    try {
      const response = await fetch(url, options);
      // if (!response.ok) {
      //   throw new Error(`HTTP error! Status: ${response.status}`);
      // }

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      if (typeof result?.data === 'string') {
        try {
          result.data = JSON.parse(result.data);
        } catch (parseError) {
          console.warn('Failed to parse result.data:', parseError);
          result.data = [];
        }
      }
      return result?.data || null; // Return the response data
    } catch (error) {
      return null;
    } finally {
      setLoading(false); // Always reset loading state
    }
  };

  return { createBackgroundCheckOrder, loading };
};

export const useGetBackgroundCheckOrder = () => {
  const [loading, setLoading] = React.useState(false);

  const getBackgroundCheckOrder = async (body, service) => {
    setLoading(true);
    const options = {
      method: 'POST',
      headers: initialOptions.headers,
      body: JSON.stringify(body),
    };
    const url = '/ExternalService/checkbgresult';

    try {
      // Fetch data from the API
      const response = await fetch(`${url}`, options);

      // Check if the response is ok (status 200-299)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      if (typeof result?.data === 'string') {
        try {
          result.data = JSON.parse(result.data);
        } catch (parseError) {
          console.warn('Failed to parse result.data:', parseError);
          result.data = [];
        }
      }
      return result?.data || null; // Return the response data
    } catch (error) {
      return null; // Re-throw the error to be handled by the caller
    } finally {
      setLoading(false); // Always reset loading state
    }
  };

  return { getBackgroundCheckOrder, loading };
};

export const useGetBackgroundCheckInvite = () => {
  const [loading, setLoading] = React.useState(false);
  const getBackgroundCheckOrder = async (orderID) => {
    setLoading(true);
    const credentials = `${client_id}:${client_secret}`;
    const base64Credentials = btoa(credentials);
    const options = {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: `${base64Credentials}`,
      },
    };
    const hostname = window.location.hostname;
    const url =
      hostname.includes('localhost') || hostname.includes('192.168.18.4:86')
        ? `https://cors-anywhere.herokuapp.com/https://api.accuratebackground.com/v3/order/${orderID}/invite`
        : `https://api.accuratebackground.com/v3/order/${orderID}/invite`;
    try {
      // Fetch data from the API
      const response = await fetch(`${url}`, options);

      // Check if the response is ok (status 200-299)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      return data; // Return the response data
    } catch (error) {
      return null; // Re-throw the error to be handled by the caller
    } finally {
      setLoading(false); // Always reset loading state
    }
  };

  return { getBackgroundCheckOrder, loading };
};
